import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.914 34.914 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758ZM.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M15.776 11.94a4.138 4.138 0 0 1 .63.013.267.267 0 0 0 .052-.53 4.692 4.692 0 0 0-.711-.016.267.267 0 1 0 .029.532Zm-.836.133a4.033 4.033 0 0 0-.589.208.267.267 0 0 1-.217-.487c.216-.096.44-.175.668-.236a.267.267 0 1 1 .138.515Zm-1.85 1.087a4.1 4.1 0 0 1 .47-.413.267.267 0 1 0-.321-.427 4.633 4.633 0 0 0-.532.468.267.267 0 0 0 .382.372Zm-.545.694c-.11.178-.207.363-.289.556a.267.267 0 0 1-.49-.21c.092-.217.201-.427.326-.627a.267.267 0 0 1 .453.281Zm-.61 2.024c.006-.21.028-.418.066-.622a.267.267 0 0 0-.524-.097 4.608 4.608 0 0 0-.075.704.267.267 0 1 0 .533.015Zm.066.866c.038.206.092.408.161.605a.267.267 0 0 1-.503.177 4.575 4.575 0 0 1-.182-.685.267.267 0 1 1 .524-.097Zm.941 1.937a4.086 4.086 0 0 1-.375-.5.267.267 0 1 0-.45.286c.126.2.268.388.424.566a.267.267 0 0 0 .401-.352Zm1.181.928a4.079 4.079 0 0 1-.53-.331.267.267 0 1 0-.317.43c.19.14.391.265.6.374a.267.267 0 0 0 .247-.473Zm3.72-7.235a4.037 4.037 0 0 0-.577-.24.267.267 0 0 1 .166-.507c.224.074.443.165.653.272a.267.267 0 0 1-.242.475Zm.772.511c.16.135.31.281.447.439a.267.267 0 0 0 .401-.352 4.632 4.632 0 0 0-.505-.495.267.267 0 1 0-.343.408Zm1.205 1.717a4.053 4.053 0 0 0-.26-.569.266.266 0 1 1 .467-.258c.114.207.213.422.294.644a.267.267 0 0 1-.5.183Zm.22.926c.018.156.027.313.027.472v.064a.267.267 0 0 0 .532.008v-.036L20.6 16c0-.18-.01-.357-.03-.533a.267.267 0 0 0-.53.061Zm-.27 2.002c.078-.193.141-.392.189-.596a.267.267 0 1 1 .52.122 4.64 4.64 0 0 1-.216.674.267.267 0 0 1-.494-.2Zm-.436.799a4.08 4.08 0 0 1-.397.484.267.267 0 1 0 .385.369c.164-.171.314-.354.45-.547a.267.267 0 1 0-.438-.306Zm-1.444 1.273c.13-.069.256-.144.378-.226a.267.267 0 1 1 .298.443c-.138.092-.28.178-.428.255a.267.267 0 1 1-.248-.472Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      d: "M13.777 13.515a3.333 3.333 0 1 0 4.445 0 .333.333 0 1 0-.445.497 2.667 2.667 0 1 1-3.555 0 .333.333 0 1 0-.445-.497Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M13.334 14.667 16 16l2.667-1.333v.666s-.2 3.334-2.667 2c-2.466 1.334-2.666-2-2.666-2v-.666Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "m14 13.333 2 2.024 2-2.024V14s-.15 3.333-2 2c-1.85 1.333-2-2-2-2v-.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "m16 13.333 2.333 4h-4.666l2.333-4Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSlv = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSlv_default = SvgFlagSlv;

export { FlagSlv_default as default };
